/**
 * ダッシュボード 受注
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'
 import * as types from '../../../mutation-types/driver-types'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/dashboard/accepts`

 const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      target_date: null,
      search_type: null,
      page: null,
    selected_item: null,
    }
  }
}

 const dashboard_manifest = {

  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     *
     * @param dispatch
     * @param commit
     * @param state
     * @param search_type
     * @param target_date
     * @param page
     * @param selected_item
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit }, { search_type, target_date, page, selected_item }) {
      dispatch('saveCondition', {
        target_date: target_date,
        search_type: search_type,
        page: page,
        selected_item: selected_item,
      })
      const params = {
        target_date: target_date,
        search_type: search_type,
        page: page,
        selected_item: selected_item,
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.DRIVER_DASHBOARD_MANIFEST_PAGINATION, { content })
          resolve(content)
        })
      })
    },
    show ({ commit }, { search_type, target_date }) {
      const api_path = `${API_PATH}/${search_type}`
      const params = {
        target_date: target_date,
      }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    saveCondition (
      { commit, state },
      { target_date, search_type, page, selected_item }
    ) {
      const _target_date = (target_date !== undefined) ? target_date : state.condition.target_date
      const _search_type = (search_type !== undefined) ? search_type : state.condition.search_type
      const _page = (page !== undefined) ? page : state.condition.page
      const _selected_item = (selected_item !== undefined) ? selected_item : state.condition.selected_item

      const params = {
        target_date: _target_date,
        search_type: _search_type,
        page: _page,
        selected_item: _selected_item,
      }
      commit(types.DRIVER_DASHBOARD_MANIFEST_CONDITION, { params })
    },

    resetPagination ({ commit }) {
      commit(types.DRIVER_DASHBOARD_MANIFEST_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_DASHBOARD_MANIFEST_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_DASHBOARD_MANIFEST_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_DASHBOARD_MANIFEST_CONDITION] (state, { params }) {
      state.condition.target_date = params.target_date
      state.condition.search_type = params.search_type
      state.condition.page = params.page
      state.condition.selected_item = params.selected_item
    }
  },
 }
 export default dashboard_manifest
